import _extends from "@babel/runtime/helpers/extends";
import React, { useContext } from "react";
import { EMPTY_ARR, EMPTY_OBJ } from "../../../helpers/logic/empties";
import Typography from "../../../Typography";
import { SelectContext } from "../../contexts/SelectContext";
import BatchActions from "../BatchActions";
import useToolbar from "./hooks/useToolbar";
import { BaseToolbar, LeftActionsContainer, LeftSideContainer, RightActionsContainer, TitleContainer } from "./styled";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function Toolbar(_ref) {
  var title = _ref.title,
    _ref$titleVariant = _ref.titleVariant,
    titleVariant = _ref$titleVariant === void 0 ? "sectionTitle" : _ref$titleVariant,
    leftContent = _ref.leftContent,
    _ref$rightActions = _ref.rightActions,
    rightActions = _ref$rightActions === void 0 ? EMPTY_ARR : _ref$rightActions,
    totalNumOfTableRows = _ref.totalNumOfTableRows,
    batchActions = _ref.batchActions;
  var _useToolbar = useToolbar(rightActions),
    ActionsComponents = _useToolbar.ActionsComponents;
  var _useContext = useContext(SelectContext),
    selectLogic = _useContext.selectLogic,
    selectableRows = _useContext.selectableRows;
  var _ref2 = selectLogic || EMPTY_OBJ,
    state = _ref2.state;
  var _ref3 = state || EMPTY_OBJ,
    ids = _ref3.ids;
  var isSelectableAndSelected = selectableRows && ids && ids.length > 0;

  // If no toolbar contents are passed, the batch actions should "float" when presented, as it will not have any visible space to inhabit
  var shouldFloat = !title && !leftContent && !rightActions.length;
  return /*#__PURE__*/_jsx(BaseToolbar, {
    floating: shouldFloat,
    "data-animate": shouldFloat && isSelectableAndSelected,
    children: isSelectableAndSelected ? /*#__PURE__*/_jsx(BatchActions, _extends({
      floating: shouldFloat,
      totalNumOfTableRows: totalNumOfTableRows
    }, batchActions)) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(LeftSideContainer, {
        children: [title && /*#__PURE__*/_jsx(TitleContainer, {
          children: /*#__PURE__*/_jsx(Typography, {
            variant: titleVariant,
            children: title
          })
        }), leftContent && /*#__PURE__*/_jsx(LeftActionsContainer, {
          children: leftContent
        })]
      }), rightActions.length > 0 && /*#__PURE__*/_jsx(RightActionsContainer, {
        children: ActionsComponents
      })]
    })
  });
}
export default Toolbar;